/* eslint-disable jira/filename-case */
export const generateViewId = (...ids: string[]): string => ids.join('/');
